import { gql } from '@apollo/client';
import { ORDER_TABLE_PROFILE_FIELDS } from '@/graphql/fragments/order_table_profiles';

export const QUERY_ORDER_TABLE_PROFILES = gql`
    ${ORDER_TABLE_PROFILE_FIELDS}
    query OrderTableProfiles(
        $where: order_table_profiles_bool_exp = {}
        $order_by: [order_table_profiles_order_by!] = []
    ) {
        order_table_profiles(where: $where, order_by: $order_by) {
            ...OrderTableProfileFields
        }
    }
`;

export const QUERY_ORDER_TABLE_PROFILE_BY_PK = gql`
    ${ORDER_TABLE_PROFILE_FIELDS}
    query OrderTableProfileByPk($order_table_profile_id: uuid!) {
        order_table_profiles_by_pk(order_table_profile_id: $order_table_profile_id) {
            ...OrderTableProfileFields
        }
    }
`;
